
import { Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import AuthMixin from "../../mixins/auth.mixin";
import { IMaterial, MaterialType } from "shared/entities/material";
import { Api } from "shared/api";
import { apiHandler } from "@/services/api-handler";

@Component({})
export default class ManageMaterials extends mixins(AuthMixin) {
    MaterialType = MaterialType;
    materials: IMaterial[] = [];
    groupedMaterials: Record<string, IMaterial[]> = {};
    materialCategories: string[] = [];

    currentlyEditingCategory: string | null = null;
    editableCategoryName = "";

    async mounted() {
        await this.loadMaterials();
    }

    @Watch("materials", { deep: true })
    private onMaterialsChanged() {
        this.materialCategories = this.materials.map(m => m.category).filter((v, i, a) => a.indexOf(v) === i).sort();
        this.groupedMaterials = {};
        for (const category of this.materialCategories) {
            this.groupedMaterials[category] = this.materials.filter(m => m.category === category).sort((a, b) => a.order - b.order);
        }
    }

    private async loadMaterials() {
        this.materials = await apiHandler(() => Api.material.Get());
    }

    editCategory(category: string) {
        this.currentlyEditingCategory = category;
        this.editableCategoryName = category;
    }

    isEditingCategory(category: string): boolean {
        return this.currentlyEditingCategory === category;
    }

    async saveCategoryName(originalCategory: string) {
        if (originalCategory !== this.editableCategoryName) {
            for (const material of this.materials) {
                if (material.category === originalCategory) {
                    material.category = this.editableCategoryName;
                    await apiHandler(() => Api.material[material.id].Patch({ category: this.editableCategoryName }));
                }
            }
        }
        this.currentlyEditingCategory = null;
        this.editableCategoryName = "";
        await this.loadMaterials();
    }

    async remove(material: IMaterial) {
        if (!confirm(`Are you sure you want to remove ${material.title}`)) {
            return;
        }
        await Api.material[material.id].Delete();
        alert("Material has been removed.");
        await this.loadMaterials();
    }

    async decreaseOrder(material: IMaterial, $event: MouseEvent) {
        $event.preventDefault();
        if (material.order <= 1) return;
        const previous = this.groupedMaterials[material.category].filter(obm => obm.order === material.order - 1);
        if(previous && previous.length >= 1) {
            await apiHandler(() => Api.material[previous[0].id].Patch({order: ++previous[0].order}));
        }
        await apiHandler(() => Api.material[material.id].Patch({order: --material.order}));
    }

    async increaseOrder(material: IMaterial, $event: MouseEvent) {
        $event.preventDefault();
        if(material.order >= this.groupedMaterials[material.category].length) return;
        const previous = this.groupedMaterials[material.category].filter(obm => obm.order === material.order + 1);
        if(previous && previous.length >= 1) {
            await apiHandler(() => Api.material[previous[0].id].Patch({order: --previous[0].order}));
        }
        await apiHandler(() => Api.material[material.id].Patch({order: ++material.order}));
    }
}

